import React from 'react';
import { UserButton, useUser } from '@clerk/clerk-react';

export const UserProfile: React.FC = () => {
  const { user, isLoaded } = useUser();

  if (!isLoaded) {
    return <div style={{ color: 'white', padding: '8px' }}>Loading...</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <div className="user-profile" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <UserButton
        afterSignOutUrl="/"
        userProfileProps={{
          appearance: {
            elements: {
              emailAddressesSection: { display: 'none' },
              connectedAccountsSection: { display: 'none' },
              apiKeysSection: { display: 'none' }
            }
          }
        }}
      />
    </div>
  );
};
